(() => {
  const BAR_SELECTOR = '[data-fsb]';
  const AMOUNT_TOKEN = '__AMOUNT__';

  function getStorefrontRate() {
    // Shopify exposes storefront currency rate in JS; not available in Liquid.
    // If not present, fallback to 1 (no conversion).
    const rate = window.Shopify && Shopify.currency && Shopify.currency.rate;
    const n = Number(rate);
    return Number.isFinite(n) && n > 0 ? n : 1;
  }

  function formatMoneyFromCents(cents, currency, locale) {
    const amount = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(locale || undefined, {
        style: 'currency',
        currency: currency || 'EUR',
        currencyDisplay: 'symbol'
      }).format(amount);
    } catch (e) {
      return `${amount.toFixed(2)} ${currency || ''}`.trim();
    }
  }

  function updateBar(bar) {
    if (!bar) return;

    const baseThresholdCents = parseInt(bar.dataset.baseThresholdCents || '0', 10);
    const cartTotalCents = parseInt(bar.dataset.cartTotalCents || '0', 10);
    const currency = bar.dataset.currency || 'EUR';
    const locale = bar.dataset.locale || undefined;

    const remainingTemplate = bar.dataset.remainingTemplate || `Only ${AMOUNT_TOKEN} away from free shipping`;
    const unlockedText = bar.dataset.unlockedText || 'Free shipping unlocked!';
    const labelText = bar.dataset.labelText || 'Free shipping';

    // Convert base threshold (store currency) -> active currency using storefront rate
    const rate = getStorefrontRate();
    const thresholdCents = Math.max(0, Math.round(baseThresholdCents * rate));

    if (!thresholdCents) return;

    const unlocked = cartTotalCents >= thresholdCents;
    const remainingCents = unlocked ? 0 : (thresholdCents - cartTotalCents);

    const progressRatio = Math.min(cartTotalCents / thresholdCents, 1);
    const progressPct = Math.round(progressRatio * 100);

    const textEl = bar.querySelector('[data-fsb-text]');
    const progressEl = bar.querySelector('[data-fsb-progress]');
    const trackEl = bar.querySelector('.fsb__track');
    const labelEl = bar.querySelector('[data-fsb-label]');

    if (progressEl) progressEl.style.width = `${progressPct}%`;
    if (trackEl) trackEl.setAttribute('aria-valuenow', String(progressPct));

    if (labelEl) labelEl.textContent = labelText;

    if (textEl) {
      if (unlocked) {
        textEl.textContent = unlockedText;
      } else {
        const amountStr = formatMoneyFromCents(remainingCents, currency, locale);
        textEl.textContent = remainingTemplate.replace(AMOUNT_TOKEN, amountStr);
      }
    }

    bar.classList.toggle('is-unlocked', unlocked);
  }

  function refreshAll(root = document) {
    root.querySelectorAll(BAR_SELECTOR).forEach(updateBar);
  }

  // Initial
  document.addEventListener('DOMContentLoaded', () => refreshAll());

  // Shopify section reload (theme editor, ajax renders)
  document.addEventListener('shopify:section:load', () => refreshAll());

  // Generic safety net for cart-drawer ajax updates:
  let raf = null;
  const mo = new MutationObserver(() => {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => refreshAll());
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
